import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-popin-title',
    templateUrl: './popin-title.component.html',
    styleUrls: [
        './popin-title.component.scss'
    ],
    standalone: false
})
export class PopinTitleComponent
{
    @Input() title: string = '';
}
